/* eslint-disable import/prefer-default-export */
/* eslint-disable react/prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';
import { useLocalizedFromContext } from 'data/Localization';

export const Crop47 = ({ title, fill, ...props }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 70 70"
    enableBackground="new 0 0 70 70"
    {...props}
  >
    <title>{useLocalizedFromContext(title)}</title>
    <path
      fill={fill || '#839CA9'}
      d="M47.4,58.7H37.3c0-1.9-0.1-5.6-0.1-10c0.6,0.2,1.1,0.3,1.6,0.3c0.6,0,1.2-0.1,1.7-0.3
      c2.7-1,4.5-4.4,6.1-11.2c0.2-0.6-0.1-1.3-0.7-1.6c-0.6-0.3-1.3-0.2-1.8,0.2c0,0-2.2,2.1-7,5.5c0-0.6,0-1.3,0-1.9c0,0,0,0,0-0.1
      s0-0.2,0-0.3c0-1.8,0-3.6,0-5.4c1.9-0.4,3-1.6,3.6-3.1c0.1-0.1,0.1-0.3,0.2-0.4c0.4-1.2,0.7-2.5,0.9-3.7l0.2-0.9
      c0.5-3.1,3.5-5.5,3.5-5.5c0.4-0.3,0.6-0.8,0.5-1.3s-0.4-0.9-0.8-1.2c-1.5-0.8-3.1-1-4.7-0.5v-4.9c0-1.7-0.6-3.4-1.8-4.9
      c-0.6-0.8-1.7-1.2-2.8-1.2l0,0c-1.1,0-2.1,0.4-2.8,1.2l0,0c-1.2,1.4-1.8,3.1-1.8,4.8v4.9c-1.7-0.5-3.4-0.3-5.1,0.6
      c-0.4,0.2-0.7,0.7-0.8,1.2c0,0.5,0.2,1,0.5,1.3c0,0,3,2.5,3.5,5.5l0.2,0.9c0.5,2.9,1.1,6.5,4.6,7.2c0,1.2,0,2.4,0,3.7
      c-2.8-1.3-6.6-4.8-8.6-7.2c-0.5-0.5-1.2-0.7-1.8-0.4c-0.6,0.3-0.9,1-0.8,1.7c1.6,6.6,3.9,10.4,7,11.6c0.6,0.2,1.3,0.4,2,0.4
      c0.8,0,1.5-0.2,2.3-0.5c0,0.4,0,0.8,0,1.2v0.1c0,1.4,0,2.8,0,4.2c-5.3-3.6-12-2.5-12.4-2.5c-0.8,0.1-1.3,0.8-1.2,1.6
      c0,0.8,0.6,1.4,1.4,1.4c1,0.1,2.1,1.2,3.2,2.4s2.4,2.6,4.1,3.3c1.8,0.7,3,0.9,4,0.9c0.3,0,0.6,0,0.9-0.1c0,1.2,0,2.2,0,3H23.8
      c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h12l0,0h11.6c0.8,0,1.5-0.7,1.5-1.5S48.2,58.7,47.4,58.7z M30.9,40.4
      c-1.1-0.4-2.2-1.6-3.1-3.5c1.6,1.4,3.4,2.7,5.2,3.5C32.2,40.6,31.5,40.7,30.9,40.4z M42.4,41.4c-0.7,2-1.7,4-2.9,4.5
      c-0.2,0.1-0.9,0.3-2.3-0.4c0-0.1,0-0.2,0-0.2C39.3,43.7,41,42.5,42.4,41.4z M41.4,20c-1,1.3-2.1,3.1-2.5,5.2
      c-0.4-0.8-0.9-1.6-1.4-2.4C38.9,21.2,40.2,20.3,41.4,20z M34.1,12.3c0-1,0.4-2,1.2-3l0,0c0,0,0.2-0.1,0.5-0.1l0,0
      c0.3,0,0.4,0.1,0.5,0.1c0.8,0.9,1.2,1.9,1.2,3v6.5c-0.6,0.5-1.2,1-1.7,1.6c-0.5-0.5-1-1-1.5-1.5L34.1,12.3z M30.4,52.1
      c-1.1-0.4-2.1-1.5-3-2.6c-0.1-0.1-0.2-0.3-0.4-0.4c2.3,0.3,5.1,1.2,7.2,3.4v0.1C33.3,52.9,32.4,52.9,30.4,52.1z M32.5,26.2l-0.2-0.9
      c-0.4-2.2-1.6-4-2.6-5.3c0.3,0,0.6,0.1,0.9,0.2c3.3,1.3,6.1,7.1,7.2,9.8c-0.4,0.8-1,1.1-2,1.1h-0.1h-0.1h-0.1h-0.1
      C33.5,31,33.1,30,32.5,26.2z"
    />
  </svg>
);

Crop47.defaultProps = {
  title: 'maise',
};

Crop47.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
};
